import component from "containers/StaticPages/pages/Licenses";

export default {
  key: "powur-licenses",
  title: "Licenses",
  path: "/:user?/licenses",
  pageName: "Licenses",
  linkTarget: "/licenses",
  component,
};
